import React from 'react';
import { FaHeartbeat } from 'react-icons/fa';

const CtaSection = () => {
    return (
        <section className="py-12 relative">
            <div className="mx-auto px-4">
                <div
                    className="rounded-[3rem] p-12 md:p-24 relative overflow-hidden shadow-2xl"
                    style={{ background: '#29ABE2' }}
                >
                    {/* Single subtle topo/dot texture — no gradient, no opacity stacking */}
                    <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(255,255,255,0.07)_1px,transparent_1px)] bg-[length:20px_20px]" />

                    <div className="relative z-10 flex flex-col lg:flex-row lg:items-center justify-between gap-16">
                        <div className="max-w-2xl">
                            <h2 className="text-3xl md:text-5xl font-black text-white mb-8 tracking-tight">
                                Ready to receive <br />
                                the best care?
                            </h2>
                            <p className="text-white/80 text-lg font-medium mb-12 leading-relaxed">
                                Join thousands of Kenyan families who have upgraded their healthcare experience with NurseConnect.
                            </p>
                            <div className="flex flex-col sm:flex-row gap-5">
                                <button
                                    onClick={() => {
                                        const patientProc = document.getElementById('patient-process')
                                        if (patientProc) {
                                            patientProc.scrollIntoView({ behavior: 'smooth' })
                                        }
                                    }}
                                    className="h-16 px-12 bg-white text-[#29ABE2] font-black text-lg rounded-2xl hover:bg-slate-50 transition-all shadow-2xl hover:-translate-y-1">
                                    Get A Verified Nurse
                                </button>
                            </div>
                        </div>
                        <div className="hidden lg:block">
                            <div className="relative">
                                <div className="absolute inset-0 bg-white/10 rounded-full blur-3xl" />
                                <div className="relative size-32 md:size-48 lg:size-64 rounded-full border-[8px] md:border-[12px] lg:border-[16px] border-white/10 flex items-center justify-center mx-auto lg:mx-0">
                                    <FaHeartbeat className="text-4xl md:text-6xl lg:text-[100px] text-white/20" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CtaSection;